// Editing state.
const state = {
  editing: false
}

// Editing actions.
const actions = {
  /**
   * Set the Editing.
   */
  setEditing ({ commit }, editing) {
    commit('SET_EDITING', editing)
  }
}

// Editing state mutations.
const mutations = {
  SET_EDITING (state, editing) {
    state.editing = editing
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, actions, mutations
}
